module.exports = __webpack_public_path__ + "static/media/RP-35.323484ca.pdf";